export default {
  companySurveysAnalyticsMetadata: {
    titleTabs: {
      statistic: 'Statistic',
      wellbeing: 'Well-being',
      burnout: 'Burnout',
    },

    cycleTitle: 'Actual research cycles with dates',
    proportionTitle: 'Percentage of employees who completed the survey by team',
    employeeTitle: 'Total employees',
    joinedTitle: 'Joined to surveys',
    percentTitle: 'Percentage of employees who completed the surveys',
    dynamicTitle: 'Dynamics of survey responses',
    all: 'All',

    cycleHeaders: {
      cycle: 'Cycle',
      startDate: 'Start date',
    },
    proportionHeaders: {
      div1: 'Department',
      div2: 'Department 2',
      team: 'Team',
      connected: 'Connected',
      proportion: 'Proportion',
    },

    commonBurnoutTitle: 'The «Common burnout» block',
    commonBurnoutSubTitle:
      'The indicator is calculated for employees who answered more than 80% of the questions. The number of such employees is indicated in the center of the diagram.',
    commonBurnoutDesc: `<p><em>The common burnout rate</em></p>
          <p>
            It is a state of emotional, psychological and physical exhaustion,
            which often develops as a result of prolonged experience of chronic stress in the
            workplace. This phenomenon can affect people in various professional fields and
            job levels. It manifests itself in the form of three key components:
          </p>
          <ol>
            <li>
              <strong>Emotional burnout</strong> is characterized by excessive fatigue,
              a lack of energy and a feeling of emotional exhaustion.
            </li>
            <li>
              <strong>Depersonalization (or Apathy)</strong> is expressed in a detached, cynical
              attitude towards others, clients or colleagues.
            </li>
            <li>
              <strong>Professional efficiency</strong> decreases, which leads to loss of
              satisfaction from achievements in professional activity.
            </li>
          </ol>
          <p>
            As a result of <strong>burnout</strong> people may lose motivation, experience
            worry and, eventually, face serious consequences for your
            physical and mental health.
          </p>
          <p>
            Early recognition and effective burnout strategies are important to maintain
            the health and professional well-being of employees.
          </p>`,
    commonBurnout: 'Common burnout',
    commonBurnoutDynamic: 'Common burnout in dynamics',
    commonBurnoutEmployee: 'Number of employees by burnout level in teams',
    commonBurnoutTitleTabs: {
      common: 'Common',
      stages: 'Stages',
    },

    emotionalBurnoutTitle: 'The «Emotional burnout» block',
    emotionalBurnoutSubTitle:
      'The indicator is calculated for employees who answered more than 80% of the questions. The number of such employees is indicated in the center of the diagram.',
    emotionalBurnoutDesc: `<p><em>Emotional burnout (exhaustion)</em></p>
          <p>
            Emotional burnout is one of the key components of the syndrome of professional
            burnout, which is characterized by a feeling of emotional and physical exhaustion,
            caused by excessive or prolonged work load. Emotional exhaustion
            it may occur when an employee experiences excessive stress and pressure, does not receive
            support or does not have the ability to effectively cope with emotional
            feelings. This aspect of burnout focuses on the emotional resources that
            an employee spends in the course of performing professional duties.
          </p>

          <p>The main features of emotional burnout include:</p>

          <ul class="pl-0">
            <li>
              <strong>Fatigue and exhaustion:</strong> an employee is constantly tired,
              mental and physical exhaustion even after small loads.
            </li>
            <li>
              <strong>Loss of energy and emotional downturns:</strong> feeling of loss of energy and
              exhaustion even at the beginning of the working day, loss of interest in work and a feeling of indifference
              to professional tasks.
            </li>
            <li>
              <strong>Feeling helpless:</strong> an employee may feel helpless and
              unable to cope with every day, sometimes even the simplest, tasks.
            </li>
            <li>
              <strong>Emotional detachment:</strong> detachment and a sense of emotional
              distance from others, including colleagues and clients.
            </li>
            <li>
              <strong>Irritability:</strong> constant feeling of irritation, decreased level of
              tolerance in response to minor or everyday problems.
            </li>
            <li>
              <strong>Emotional emptiness:</strong> feeling of emotional emptiness and absence
              enthusiasm.
            </li>
            <li>
              <strong>Difficult stress management:</strong> rapid exhaustion of emotional
              resources in stressful situations, strong and long-lasting experiences.
            </li>
          </ul>`,
    emotionalBurnout: 'Emotional burnout',
    emotionalBurnoutDynamic: 'Emotional burnout in dynamics',
    emotionalBurnoutFactors: 'Emotional burnout by factors',

    employeeWell: {
      titleTabs: {
        statistic: 'Statistic',
        participation: 'Participation',
        enps: 'ENPS',
        emotion: 'Emotion',
      },
    },

    depersonalizationBurnoutTitle: 'The «Depersonalization» block',
    depersonalizationBurnoutSubTitle:
      'The indicator is calculated for employees who answered more than 80% of the questions. The number of such employees is indicated in the center of the diagram.',
    depersonalizationBurnoutDesc: `
        <p>
          Depersonalization means the attitude of an employee towards his work, clients, colleagues and
          professional duties with a cynical, indifferent and aloof manner. This
          the burnout component. Depersonalization is a serious factor affecting quality
          performance, team effectiveness and overall employee satisfaction.
        </p>

        <p>The main features of depersonalization within the framework of burnout include:</p>

        <ol class="pl-0">
          <li>
            <strong>Cynical attitude:</strong> an employee may be cynical and skeptical
            in relation to clients, colleagues and work. He may be indifferent to their
            needs, problems, questions and requests.
          </li>
          <li>
            <strong>Alienation:</strong> alienation is manifested in what an employee feels
            emotional distance from others. This is expressed in a lack of interest in their
            feelings, feelings and indifference to what is happening around.
          </li>
          <li>
            <strong>Negative stereotypes:</strong> an employee with depersonalization can develop
            negative stereotypes about clients, colleagues, and professional tasks. It may
            lead to the formation of biased opinions and negative assessments.
          </li>
          <li>
            <strong>Decreased Empathy, sarcasm and irony:</strong> in an attempt to cope with the negative
            with emotions and alienation, an employee can use sarcasm and irony in communicating with
            clients and colleagues, which exacerbates the problems of interaction.
          </li>
          <li>
            <strong>Lack Of Desire To Help:</strong> employees may lose the desire to help
            for others, there is a lack of initiative in solving problems, an unwillingness to go beyond
            minimum responsibilities.
          </li>
        </ol>`,
    depersonalizationBurnout: 'Depersonalization',
    depersonalizationBurnoutDynamic: 'Depersonalization of dynamics',
    depersonalizationBurnoutFactors: 'Depersonalization by factors',

    professionalEfficiencyTitle: 'The «Professional Efficiency» block',
    professionalEfficiencySubTitle:
      'The indicator is calculated for employees who answered more than 80% of the questions. The number of such employees is indicated in the center of the diagram.',
    professionalEfficiencyDesc: `
          <p>
            This component reflects a sense of loss of personal importance, professional
            efficiency and reduced satisfaction with their work.
          </p>

          <p><strong>The main signs of a decline in personal fulfillment include:</strong></p>

          <ul class="pl-0">
            <li>
              <strong>Reduced job satisfaction:</strong> an employee feels that his
              professional results and efforts cease to bring him satisfaction.
            </li>
            <li>
              <strong>Loss of interest:</strong> decreased interest in professional tasks and
              loss of internal motivation.
            </li>
            <li>
              <strong>Doubt about your own abilities:</strong> the appearance of doubts about your
              competence and ability to achieve success in work.
            </li>
            <li>
              <strong>Feeling of uselessness:</strong> feeling of uselessness and inefficiency in
              within the framework of professional activity.
            </li>
            <li>
              <strong>Lack of achievements:</strong> the feeling that professional efforts are not
              they bring noticeable results or achievements.
            </li>
            <li>
              <strong>Loss of meaning:</strong> loss of meaning and purpose in professional activity,
              a sense of monotony and routine.
            </li>
            <li>
              <strong>Avoiding responsibility:</strong> tendency to avoid or delay
              performing professional duties, finding an opportunity to shift responsibility
              on others.
            </li>
          </ul>`,
    professionalEfficiency: 'Professional efficiency',
    professionalEfficiencyDynamic: 'Professional performance dynamics',
    professionalEfficiencyFactors: 'Professional effectiveness by factors',

    burnoutSubTitle:
      'The graph shows the change in burnout components between survey cycles based on the points scored by employees. Allows you to track the dynamics of burnout changes even if the burnout stage has not changed.',
    burnoutDynamic: 'Burnout dynamics',
    enpsDesc: {
      support: `
          <em>Supporters</em> are those respondents who gave the highest scores of 8, 9 or 10. These
          people are most likely the most important key to analyzing the results and
          improvement of the situation. It is important to understand what exactly this group of respondents likes about the company,
          what made them give such a high rating. Use the information you receive to
          hiring and retaining the best talent.
        `,
      loyal: `
           <em>Loyal</em> - survey participants who scored 7 points, they are generally
          we are satisfied with the conditions in the company, we do our work «formally» efficiently, but without
          striving to make the result as good as possible. We are ready to recommend the company, but at the same time
          they can change their place of work if a more interesting offer appears.
        `,
      skeptic: `
           <em>Skeptics</em> - the respondent is considered a skeptic when he chooses 5 or 6 points. This
          employees who see problems and are not very happy with the working conditions in the company. Very
          It is important to listen to them and find out the causes of discomfort in order to try to change the situation.
          and thereby increase loyalty.
        `,
      critic: `
           <em>Critics</em> - respondents score 0-4 points. These employees are unhappy
          working conditions in the company. As a rule, they openly criticize processes and culture.
          Dissatisfaction can affect the quality of work — employees perform their duties
          formally. They don't want to change anything and won't support the changes. With this category
          It is important for the staff to establish contact: find out the reason for the disappointment and try to improve
          the situation. Critics are an important asset of the company — they have the courage to point out
          real problems.
        `,
    },
    eNPS: 'eNPS',
    emotion: {
      title: 'The emotional state of employees',
      desc: 'The answers to the question «Describe your emotional state now» on a scale from 0 to 5 were taken into account',
      anxietyLevel: 'Anxiety level',
      averageTitle: 'The average indicator of the mood company',
    },
    participation: {
      participationTitle: 'The «Involvement and Satisfaction» block',
      participationDesc:
        'The block shows data on indicators of overall engagement and satisfaction, as well as the proportion of positive responses for 11 satisfaction factors. The satisfaction factors are listed in the order of their importance.',
      involvementDynamic: 'Involvement in dynamics',
      contentmentDynamic: 'Satisfaction in dynamics',
      summaryFactors: 'Summary of factors',
      summaryFactorsTable:
        'The table shows the proportion of positive responses (only responses containing a score)',
      summary: 'Summary of the company',
      summaryTeam: 'Summary of the teams',
      involvement: 'Involvement',
      involvementDesc:
        'the indicator reflects employee motivation and productivity the working environment in the company / department.',
      involvementFactors: 'Employee involvement factors',
      recommendationsTitle: 'Recommendations for increasing involvement:',
      recommendationsDesc: {
        firstStep: `<p><em>1. Analysis of the results by division</em></p>`,
        firstStepDesc: `At this step, the manager can identify problem areas in the department regarding
        estimates for the company as a whole and determine priorities for work (it is recommended to take no more than
        three problem areas for the next quarter)`,
        secondStep: `<p><em>2. Understand how the manager himself can influence the involvement of the team.</em></p>`,
        secondStepDesc: `The results of the employee survey are feedback for the company and for the manager.
        Based on this data, the manager can adjust his management methods.
        The head has a serious impact on engagement in his department, so he
        needs to maintain your level of engagement at a high level and demonstrate it
        to the team, «infecting» it with his enthusiasm. In addition, the head informs the team in many ways
        the vision of the company's strategy and information from other departments, so you need to take care of
        that there is enough information and it is presented in the right way.`,
        thirdStep: `<p><em>3. Ask the team about how to improve the work environment.</em></p>`,
        thirdStepDesc: `Employees fill out a survey hoping that their opinion will be heard and the company is ready
        work to improve the employee experience. In the end
        The positive experience of employees influences the fact that the best specialists come to work.
        They join the company and stay in it for a long time. The manager should communicate the results of the survey to
        employees of their department, drawing their attention to both positive and negative aspects.`,
        time: `<p>
        <em
          >It is necessary to allocate a separate time for discussion – from 1 to 2 hours, and it is also better in advance
          identify priority factors for the work. It is useful to ask the team open-ended questions:</em
        >
      </p>`,
        firstQuestion: 'What do you think are the most problematic aspects of the survey?',
        secondQuestion: `What exactly do you dislike about this or that aspect of the work (name the factors, explain their
meaning, which questions are included)?`,
        thirdQuestion: `What are we ready to focus on as a team in the next month/2 months/quarter?`,
      },
      contentment: 'Satisfaction',
      contentmentDesc:
        'identification of the causes of frustration and stress, assessment by 11 factors. This is how employees feel when they cross the threshold of the office or how they evaluate  another year spent with the company.',
      successConditions: 'Conditions for success',
      successConditionsDesc:
        'The «Conditions for success» that the company creates for an employee are a sufficient number of resources and tools for the successful performance of his work duties, as well as free access to necessary information and a well–established decision-making process.',
      developmentOpportunities: 'Opportunities for development',
      developmentOpportunitiesDesc:
        "«Development opportunities» reflect an employee's attitude to what career or professional development opportunities the company provides to him – whether he sees growth opportunities, whether there is access to training, etc.",

      rewardRecognition: 'Reward and recognition',
      rewardRecognitionDesc:
        "The «Reward and recognition» factor reflects the employee's understanding that his work is appreciated and fairly paid.",

      lead: 'Lead',
      leadDesc:
        "The «Lead» factor is characterized by a degree of loyalty to his supervisor and satisfaction with working with him, which depends on his managerial skills: the ability to set goals, give feedback, take care of the career growth of employees and timely broadcast information from the company's management.",

      team: 'Team',
      teamDesc:
        "The «Team» factor reflects an employee's attitude to the atmosphere in his team, as well as to the degree of its organization – to how well coordinated the work in the team is and how responsibility is distributed.",

      authority: 'Authority',
      authorityDesc:
        "«Authority» is an employee's perception of the degree of freedom that the company provides him with in his work, the ability to make independent decisions, plan his work, and complete tasks.",

      consist: 'Consistency',
      consistDesc:
        'Consistency is determined by how well, in the opinion of an employee, his functional role and the company are suitable for him – he understands what is required of him in his current position, he likes his tasks and he believes in the success of the company in which he works.',

      clientFocus: 'Focus on the client',
      clientFocusDesc:
        "The «Focus on the client» factor shows the employee's attitude to the product that the company produces: whether, in his opinion, the company's customers are satisfied, whether he is ready to recommend the product to his friends.",

      respect: 'Respect for employees',
      respectDesc:
        'The assessment of the «Respect for personality» factor is based on how fairly each person is treated in the company and how freely everyone can express their ideas and opinions.',

      innovation: 'Innovations',
      innovationDesc:
        "The «Innovation» factor reflects employees' perception of the culture of innovation in the company: whether they can implement new ideas, whether innovative solutions are used in their work.",

      collaboration: 'Cross-functional interaction',
      collaborationDesc:
        '«Cross-functional interaction» or collaboration is an attitude towards the quality of employee interaction between different departments of a company.',
      recommendationsFinalTitle:
        'Recommendations for further actions to increase the level of satisfaction:',
      recommendationsFinalDesc: {
        first:
          'Based on the survey results, we recommend conducting focus groups with the most problematic teams and divisions — to clarify what caused the poor results, reveal specific ones  «problematic» factors and opportunities to improve the situation, according to the employees themselves.',
        second:
          'Then, in a session with management, develop a roadmap for changes: define actions on key issues and hot spots, work out maintenance tools the most powerful satisfaction factors. At the exit— a realistic plan to increase satisfaction level based on data and statistics.',
      },
      summaryTableTitle: 'Name',
      summaryTableValue: 'Value',
    },
    answersTableHeaders: {
      question: 'Question',
      supporters: 'Positive',
      loyal: 'Loyal',
      skeptics: 'Skeptical',
      neutral: 'Neutral',
      critics: 'Negative',
    },
    burnoutTableHeaders: {
      team: 'Team',
      question: 'Question',
      never: 'Never',
      very_rare: 'Very rare',
      rarely: 'Rarely',
      sometimes: 'Sometimes',
      often: 'Often',
      very_often: 'Very often',
      almost_always: 'Almost always',
    },
    chartsData: {
      positive_answer: 'Positive',
      loyal_answer: 'Loyal',
      skeptic_answer: 'Skeptic',
      negative_answer: 'Negative',
      neutral_answer: 'Neutral',

      extremely_low_expression: 'No expression',
      low_expression: 'Low',
      medium_expression: 'Medium',
      high_expression: 'High',
      extremely_high_expression: 'Extremely high',
      insufficient_data: 'Insufficient data',

      extremely_high_prof_efficiency: 'Extremely high',
      high_prof_efficiency: 'High',
      medium_prof_efficiency: 'Medium',
      low_prof_efficiency: 'Low',

      loyal: 'Loyal',
      skeptics: 'Skeptics',
      supporters: 'Supporters',
      critics: 'Critics',
    },
    burnoutStages: {
      burnoutDepersonalizationTableTitle: 'Depersonalization of dynamics by people',
      burnoutEfficiencyTableTitle: 'Professional efficiency dynamics by people',
      burnoutEmotionTableTitle: 'Emotional burnout dynamics by people',
      burnoutGeneralTableTitle: 'General burnout dynamics by people',
      burnoutStagesTableTitle: 'Stages of employee burnout',
      burnoutStagesTitle: `<p>
            The table contains information about each employee and their current burnout level, including
            components of burnout.
          </p>
          <ul>
            <li>
              <strong>Reliability:</strong> Calculation based on the number of employee responses related 
              to a specific component. The burnout level is calculated if the reliability is not less than 80%.
            </li>
            <li>
              <strong>The amount of points:</strong> The numerical value of the employee's final results, 
              allowing for conditional ranking. The more points, the more pronounced burnout. The maximum value is 126.
            </li>
          </ul>
          <p>
            To filter by departments and employees, click on the desired value in the table below.
          </p>`,
      burnoutStagesSubTitle: `<p>
            The tables below reflect the change in the severity of burnout and its components among employees.
          </p>
      `,
      EmployeeTableHeader: {
        div1: 'Department 1',
        div2: 'Department 2',
        team: 'Team',
        last_name: 'Last name',
        first_name: 'First name',
        email: 'email',
        emotional_burnout: 'Emotional burnout',
        emotional_burnout_reliability: 'EB reliability',
        professional_efficiency_reliability: 'PE reliability',
        professional_efficiency: 'Prof efficiency',
        depersonalization: 'Depersonalization',
        depersonalization_reliability: 'D reliability',
        common_burnout: 'Common',
        sum_score: 'Summary',
        employee: 'Employee',
      },
    },

    filters: {
      cycle: 'Cycle',
      team: 'Team',
      div1: 'Department',
      div2: 'Department 2',
      lastname: 'Lastname',
    },
    summary: 'Summary',
    summaryCompanyAndTeam: {
      authority: 'Authority',
      consistency: 'Consistency',
      contentment: 'Satisfaction',
      cross_f_interaction: 'Cross-functional interaction',
      customer_focus: 'Focus on the client',
      development_opportunities: 'Development opportunities',
      innovation: 'Innovation',
      involvement: 'Involvement',
      lead: 'Lead',
      respect_for_staff: 'Respect for personality',
      reward_recognition: 'Reward and recognition',
      success_conditions: 'Conditions for success',
      teams: 'Teams',
      div1: 'Department 1',
      div2: 'Department 2',
      sub_div: 'Sub-department',
    },
    noData: 'No data',
    answers: 'Answers',
    cycle: 'Cycle',
    count: 'Count',
    veryDisturbing: 'Very disturbing',
    excellent: 'Excellent',
    subdivision: 'Subdivision',
    middleCount: 'Middle',
    donatChartLegend: `
      <p><b>Positive</b> - the proportion of responses containing 8, 9 or 10 points</p>
      <p><b>Loyal</b> - employee rating of 7 points
      <p><b>Skeptical</b> - score 5 and 6 points</p>
      <p><b>Negative</b> - the proportion of responses with a score of 0 - 4 points</p>
    `,
    from: 'from',
    hideAll: 'Hide all',
    showAll: 'Show all',
    placeholders: {
      team: 'Search by division',
      lastname: 'Search by last name',
    },
    linesPerPage: 'Lines per page',

    departments: 'Departments',
    exportFrom: 'from',
    allCompany: 'All company',
    activeFilters: 'Active filters',
    researchAnalytic: 'Research analytics',
  },
};
